import { Recordatorio } from '../../pages/recordatorios/models'
import { keysToSnake } from '../../utils/ObjetosUtil'
import { baseApi } from './base.api'

export const recordatoriosApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Contrato HTTP de recordatorios ligados a tareas, autorizaciones u otros elementos relacionados.
     */
    recuperarRecordatorioPorId: builder.query<Recordatorio, string>({
      query: (idRecordatorio) => `${window._env_.API_CONTEXTO_RECORDATORIOS}/${idRecordatorio}`,
    }),

    guardarRecordatorio: builder.mutation({
      query: (recordatorio) => {
        return {
          url: `${window._env_.API_CONTEXTO_RECORDATORIOS}`,
          method: 'POST',
          body: keysToSnake(recordatorio),
        }
      },
    }),

    actualizarRecordatorio: builder.mutation({
      query: ({ idRecordatorio, ...recordatorio }) => {
        return {
          url: `${window._env_.API_CONTEXTO_RECORDATORIOS}/${idRecordatorio}`,
          method: 'PUT',
          body: keysToSnake(recordatorio),
        }
      },
    }),

    // Estos endpoints relacionados usan rutas relativas; revisa el contrato backend antes de cambiarlos.

    recuperarRecordatoriosPorIdRelacionado: builder.mutation({
      query: ({ idRelacionado, ...recordatorio }) => {
        return {
          url: `relacionado/${idRelacionado}`,
          method: 'GET',
          body: keysToSnake(recordatorio),
        }
      },
    }),

    recuperarRecordatoriosPorIdRelacionadoQuery: builder.query<Recordatorio[], string>({
      query: (idRelacionado) => `/relacionado/${idRelacionado}`,
    }),
    eliminarRecordatorioPorId: builder.mutation({
      query: (idRecordatorio) => {
        return {
          url: `${window._env_.API_CONTEXTO_RECORDATORIOS}/${idRecordatorio}`,
          method: 'DELETE',
        }
      },
    }),
  }),
})

export const {
  useRecuperarRecordatoriosPorIdRelacionadoMutation,
  useRecuperarRecordatoriosPorIdRelacionadoQueryQuery,
  useRecuperarRecordatorioPorIdQuery,
  useActualizarRecordatorioMutation,
  useEliminarRecordatorioPorIdMutation,
  useGuardarRecordatorioMutation,
} = recordatoriosApi
